import { useNotificationStore } from '@/legacy/store/modules/notification'
import { NotificationType } from '@/legacy/types/notifications'
import { useLlmFeedbackApi } from './store'
import { LlmFeedback } from './types'

/**
 *
 * @param llmRawLogId
 * @param feedbackId
 * @param feedback
 */
export async function upsertFeedback(
  llmRawLogId: string,
  feedbackId: string | undefined,
  feedback: Partial<LlmFeedback>
) {
  let resp: LlmFeedback
  try {
    if (feedbackId) {
      resp = await useLlmFeedbackApi().partialUpdate({
        ids: [feedbackId],
        body: feedback,
      })
    } else {
      resp = await useLlmFeedbackApi().create({
        body: { llmRawLogId, ...feedback },
      })
    }
  } catch (err: any) {
    useNotificationStore().setNotification({
      message: 'Failed to save feedback',
      type: NotificationType.DANGER,
      error: `Error saving feedback: ${err?.message}`,
    })
    return feedbackId
  }
  return resp.feedbackId
}
